import r, { OPTIONS as z } from "../../managers/braze-instance.js";
export function attachCSS(n, t, o) {
  var c = n || document.querySelector("head"),
      e = "ab-".concat(t, "-css-definitions-").concat("5.6.0".replace(/\./g, "-"));
  if (!c) return;
  var s = c.ownerDocument || document;

  if (null == s.getElementById(e)) {
    var _n = s.createElement("style");

    _n.innerHTML = o || "", _n.id = e;

    var _t = r.sr(z.ir);

    null != _t && _n.setAttribute("nonce", _t), c.appendChild(_n);
  }
}